import { api } from "./axiosClient";
import type { Jurisdiction } from "../types/jurisdiction.types";
import { getCurrentUser } from "../auth/auth.service";

export const jurisdictionsApi = {
  searchJurisdictions: async (payload: any) => {
    const response = await api.post("/jurisdiction/search", payload);
    return response.data;
  },

  createJurisdiction: async (data: Partial<Jurisdiction>) => {
    const response = await api.post("/jurisdiction/create", data);
    return response.data;
  },

  updateJurisdiction: async (data: Partial<Jurisdiction>) => {
    const response = await api.post("/jurisdiction/edit", data);
    return response.data;
  },

  removeJurisdiction: async (id: string) => {
    return await api.post("/jurisdiction/remove", { id });
  },

  activateJurisdiction: async (id: string) => {
    return await api.post("/jurisdiction/activate", { id });
  },

  deactivateJurisdiction: async (id: string) => {
    return await api.post("/jurisdiction/deactivate", { id });
  },
};

export interface JurisdictionOption {
  id: string;
  name: string;
  isActive: boolean;
}

/**
 * The caller's organisation's jurisdictions, sorted by name, for the Clause
 * Library's filters. Inactive ones are included unless `activeOnly`: older
 * clauses may still carry them. Failure-tolerant: an empty list just leaves
 * the filter empty.
 */
export async function listJurisdictionOptions(
  opts: { activeOnly?: boolean } = {},
): Promise<JurisdictionOption[]> {
  try {
    const me = await getCurrentUser();
    const res = await jurisdictionsApi.searchJurisdictions({
      pageSize: 200,
      pageIndex: 0,
      searchText: "",
      groupIds: [`${me?.companyId}`],
      includeDeleted: false,
      ...(opts.activeOnly ? { isActive: true } : {}),
    });
    const rows = (res?.data ?? res?.items ?? []) as Jurisdiction[];
    return rows
      .filter((r) => r?.id && r.jurisdictionName)
      .map((r) => ({ id: r.id, name: r.jurisdictionName, isActive: r.isActive !== false }))
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch {
    return [];
  }
}
